<style lang="less" scoped>
</style>
<template>
  <VRemoteSelect
    v-bind="$attrs"
    item-value="id"
    :item-text="(c) => (`${c.uid}-${c.account}`)"
    :find_api="$util.api.find_outsource_contract"
    :extra-data="{platform: platform, finished: true}"
    :search_api="$util.api.outsource_contract_select_search"
    :item-default="{id: 0, uid: '', name: ''}"
    v-on="$listeners"
  />
</template>
<script>
  import VRemoteSelect from '../../../vuetify_custom/v-remote-select';
  export default {
    components: { VRemoteSelect },
    inheritAttrs: false,
    props: {
      platform: {
        type: String,
        default: ''
      }
    },
  }
</script>
